<template>
  <div class="carbonfootprint-certificate">
    <el-form
      v-for="(ruleForm, index) in formList"
      :ref="`ruleForm${index}`"
      :key="index"
      :model="ruleForm"
      :rules="rules"
      :disabled="type === 'detail'"
      size="small"
      label-width="110px"
      label-suffix=":"
    >
      <div class="certificate-title">
        <div class="certificate-title-text">绿色供应链评价{{ index + 1 }}</div>
        <eui-btn
          v-if="formList.length > 1 && componentType != 'single'"
          type="text"
          color="#E50113"
          @click="deleteCertificate(index)"
          >删除</eui-btn
        >
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="级别" prop="level">
            <el-select
              v-model="ruleForm.level"
              placeholder="请选择级别"
              style="width: 100%"
            >
              <el-option label="国家级​" :value="1" />
              <el-option label="省级​" :value="2" />
              <el-option label="其他" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="获评时间" prop="awardYear">
            <el-date-picker
              v-model="ruleForm.awardYear"
              style="width: 100%"
              type="year"
              value-format="yyyy"
              placeholder="请选择获评时间"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="评价方式" prop="evalMethod">
            <el-select
              v-model="ruleForm.evalMethod"
              placeholder="请选择评价方式"
              style="width: 100%"
            >
              <el-option label="自评价" :value="1" />
              <el-option label="委托第三方机构评价" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            class="cursor-form-item"
            label="第三方评价机构名称"
            prop="institutionName"
          >
            <el-input
              v-model="ruleForm.institutionName"
              maxlength="50"
              placeholder="请输入第三方评价机构名称"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            class="cursor-form-item"
            label="第三方机构评价报告"
            prop="reportAttachment"
          >
            <eui-upload
              ref="upload"
              :headers="headers"
              :file-list="ruleForm.reportAttachment"
              :action="fileUrl"
              :auto-upload="autoUpload"
              :show-file-list="true"
              :limit="1"
              accept=".pdf"
              text="上传文件"
              :limit-file-size="30"
              tip="最多上传1个文件，格式为PDF，大小不超过30M"
              @handleSuccess="
                (res) => uploadSuccess(res, index, 'reportAttachment')
              "
            ></eui-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="查询网址" prop="reportAddress">
            <el-input
              v-model="ruleForm.reportAddress"
              maxlength="50"
              placeholder="查询网址"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="附件" prop="otherAttachment">
            <eui-upload
              ref="upload"
              :headers="headers"
              :file-list="ruleForm.otherAttachment"
              :action="fileUrl"
              :auto-upload="autoUpload"
              :show-file-list="true"
              :limit="1"
              accept=".pdf,.jpg,.png"
              text="上传文件"
              :limit-file-size="30"
              tip="最多上传1个文件，格式为PDF、JPG、PNG，大小不超过30M"
              @handleSuccess="
                (res) => uploadSuccess(res, index, 'otherAttachment')
              "
            ></eui-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="componentType != 'single'" class="add-from">
      <eui-btn
        v-if="formList.length < 2"
        type="weak"
        icon="eicon-add"
        width="1160"
        size="40"
        icon-position="left"
        @click="addCertificate"
        >新增绿色供应链评价</eui-btn
      >
    </div>
    <!-- <el-button @click="submit">提交</el-button> -->
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import { epecToken } from '@/modules/projectA/utils/globalData';

export default {
  name: 'SupplyChain',
  components: {},
  props: {
    supplyChain: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    componentType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headers: epecToken,
      fileUrl: api.fileUploadForGreenPdfAndPic,

      autoUpload: true,
      formList: [
        {
          level: '',
          awardYear: '',
          evalMethod: '',
          institutionName: '',
          reportAttachment: [],
          reportAddress: '',
          otherAttachment: [],
        },
      ],
      rules: {
        level: [{ required: true, message: '请选择级别', trigger: 'blur' }],
        awardYear: [
          { required: true, message: '请选择获评时间', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
      // return this.$cookies.get("isLogin")
    },
  },
  created() {
    if (this.supplyChain && this.supplyChain.length > 0) {
      this.formList = JSON.parse(
        JSON.stringify(
          this.supplyChain.map((item) => {
            if (item.reportAttachmentUrl)
              item.reportAttachment = [
                {
                  name: item.reportAttachmentName,
                  url: item.reportAttachmentUrl,
                },
              ];
            if (item.otherAttachmentName)
              item.otherAttachment = [
                {
                  name: item.otherAttachmentName,
                  url: item.otherAttachmentUrl,
                },
              ];
            return item;
          })
        )
      );
    }
  },
  mounted() {
    const token = this.$cookies.get('epecToken');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (token && this.userInfo && this.userInfo.companyId) {
      this.headers = {
        'epec-sso-token': this.$cookies.get('epecToken'),
        'epec-from': 'WEB_SITE',
        'epec-locale': 'ZH',
        'epec-company-id': this.userInfo.companyId,
      };
    }
  },
  methods: {
    uploadSuccess(res, index, key) {
      console.log(res);
      if (res.success) {
        this.formList[index][key] = [
          {
            ...res.data,
            name: res.data.fileName,
            url: res.data.url,
          },
        ];
      }
    },
    deleteCertificate(index) {
      this.formList.splice(index, 1);
    },
    addCertificate() {
      this.formList.push({
        level: '',
        awardYear: '',
        evalMethod: '',
        institutionName: '',
        reportAttachment: [],
        reportAddress: '',
        otherAttachment: [],
      });
    },

    submit() {
      return new Promise((resolve, reject) => {
        const validatePromises = this.formList.map((_, index) => {
          // 注意 v-for 下的 ref 是数组，所以要 [0]
          return this.$refs[`ruleForm${index}`][0].validate();
        });

        Promise.all(validatePromises)
          .then(() => {
            console.log('✅ 全部验证通过', this.formList);
            const params = this.getParams();
            // 这里写提交接口
            resolve({
              success: true,
              data: params,
            });
          })
          .catch(() => {
            reject();
            console.log('❌ 有表单没通过验证--report');
          }); // 把所有表单的 validate() 都转成 Promise
      });
    },
    getParams() {
      return this.formList.map((_) => {
        // _.attachmentUrl = _.attachmentList && _.attachmentList[0] && _.attachmentList[0].url;
        // _.attachmentName = _.attachmentList && _.attachmentList[0] && _.attachmentList[0].name;
        _.reportAttachmentUrl =
          _.reportAttachment &&
          _.reportAttachment[0] &&
          _.reportAttachment[0].url;
        _.reportAttachmentName =
          _.reportAttachment &&
          _.reportAttachment[0] &&
          _.reportAttachment[0].name;
        _.otherAttachmentUrl =
          _.otherAttachment && _.otherAttachment[0] && _.otherAttachment[0].url;
        _.otherAttachmentName =
          _.otherAttachment &&
          _.otherAttachment[0] &&
          _.otherAttachment[0].name;
        return _;
      });
    },
    save() {
      return this.getParams();
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-title {
  width: 100%;
  height: 34px;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  .certificate-title-text {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    // font-family: PingFangSC-Medium;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    padding-left: 10px;
    z-index: 2;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 80px;
      height: 24px;
      background: linear-gradient(
        90deg,
        rgba(102, 171, 254, 0.5) 0%,
        rgba(73, 151, 246, 0) 100%
      );
      z-index: -1;
    }
  }
}
.add-from {
  margin-top: 10px;
}
::v-deep.el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}
::v-deep.el-form-item.cursor-form-item {
  .el-form-item__label {
    line-height: 1;
  }
}
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep.el-form .el-input__inner,
::v-deep.el-form .el-input,
::v-deep.el-form .el-date-editor,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep.el-radio {
  margin-right: 0px;
}
::v-deep.remark {
  padding-left: 0px !important;
}
::v-deep.el-radio__label {
  color: #333;
}
::v-deep.el-radio__input.is-checked + .el-radio__label {
  color: #333;
}
</style>
